(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Cookie", [], factory);
	else if(typeof exports === 'object')
		exports["Cookie"] = factory();
	else
		root["Cookie"] = factory();
})(this, function() {
return 